<template>
  <v-card class="p-fixed menu-card" :class="isOpen && 'open'">
    <v-card-text class="text-center">
      <div class="color-primary">
        <h2
          @click.stop="$router.push(item.path); closeMenu()"
          v-for="(item, i) of menuItems"
          :key="i"
          class="weight8"
        >
          {{item.label}}
        </h2>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import eventBus from '@/eventBus';

export default {
  name: 'menu-card',
  data: () => ({
    isOpen: false,
    menuItems: [
      {label: "Über uns", path: '/about'},
      {label: "Impressum", path: '/imprint'},
      {label: "Datenschutzerklärung", path: '/data'},
    ]
  }),
  mounted() {
    eventBus.$on('toggleMenu', (state) => {
      this.isOpen = state;
    })
    document.addEventListener('click', () => {
      if(this.isOpen)
        this.closeMenu();
    })
  },
  methods: {
    closeMenu() {
      this.isOpen = false;
      eventBus.$emit('closeMenu');
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-card {
  width: 300px;
  top: 125px;
  border-radius: 14px !important;
  padding-bottom: 20px;
  transition: opacity 0.25s;
  pointer-events: none;
  opacity: 0;
  border: 2px solid #020B2D !important;

  &.open {
    pointer-events: all;
    opacity: 1;
  }

  h2 {
    cursor: pointer;
    padding: 30px 0px;
    width: 100%;
    border-bottom: 1px solid #9FAEB8;
    transition: all 0.25s;

    &:hover {
      background-color: rgb(240, 240, 240);
    }
  }
  h2:last-child {
    margin-bottom: 0px;
  }
}
@media screen and (min-width: 500px) {
  .menu-card {
    transform: scale(0.90);
    // max-height: 100vh;
  }
}
</style>